export default __webpack_public_path__ + "static/media/lens.8e3ea641.svg";